// Per-browser preference for the file-upload crop step. On by default; the
// crop modal's "Don't ask me to crop photos" tick turns it off.
const KEY = 'crop_photos_enabled'

export function isCropEnabled() {
  try {
    return window.localStorage.getItem(KEY) !== 'false'
  } catch (e) {
    return true
  }
}

export function setCropEnabled(enabled) {
  try {
    window.localStorage.setItem(KEY, enabled ? 'true' : 'false')
  } catch (e) {
    // storage blocked: the preference just won't stick
  }
}
